import _ from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export const NODE_HIGH_LIGHT_EXP = /[-\/\\^$*+?.()|[\]{}]/g;
export const MAX_STRING_LENGTH = 4000;
export const MAX_URL_LENGTH = 4000;
export const MAX_NUM_LENGTH = 15;
export const MAX_OPTION_DISPLAY_LENGTH = 20;
export const MAX_LAYER_DISPLAY_LENGTH = 20;
export const forEachTree = (nodes, cb) => {
    nodes.forEach(((node) => {
        cb(node);
        if (node.children) {
            forEachTree(node.children, cb);
        }
    }));
};
/** 字符串 */
export function transformStringField(value) {
    return value;
}
export function validateStringField(value) {
    const validator = {
        valid: true,
        error: '',
    };
    if ((value === null || value === void 0 ? void 0 : value.length) > MAX_STRING_LENGTH) {
        validator.valid = false;
    }
    return validator;
}
/** 日期 */
export function transformDateField(value, locale) {
    if (!value || value.length !== 8)
        return '';
    if (locale === 'en') {
        return dayjs.utc(value).format('DD MMM YYYY');
    }
    return dayjs.utc(value).format('YYYY-MM-DD');
}
export function validateDateField(value) {
    const validator = {
        valid: true,
        error: '',
    };
    if (new Date(value).toString() === 'Invalid Date') {
        validator.valid = false;
    }
    return validator;
}
/** 数字 */
export function transformNumField(value) {
    return value;
}
export function validateNumField(value) {
    const validator = {
        valid: true,
        error: '',
    };
    if (!value) {
        return validator;
    }
    if (isNaN(Number(value))) {
        validator.valid = false;
        validator.error = 'VALID';
    }
    return validator;
}
/** 链接 */
export function transformUrlField(value) {
    if (!value)
        return value;
    return /(^(http|https):\/\/.*)|(^\/\/.*)/.test(value) ? value : `//${value}`;
}
export function validateUrlField(value) {
    const validator = {
        valid: true,
        error: '',
    };
    // MAX_URL_LENGTH TODO: 统一变量
    if ((value === null || value === void 0 ? void 0 : value.length) > MAX_URL_LENGTH) {
        validator.valid = false;
    }
    return validator;
}
/** 选项 */
export function transformOptionField(value, options) {
    if (!options || !options.length) {
        return [];
    }
    return _.compact(_.map(value, (optionId) => {
        const optionItem = _.find(options, { option_id: optionId });
        if (!optionItem)
            return null;
        return {
            id: optionItem.option_id,
            label: optionItem.option_text,
            data: optionItem,
        };
    }));
}
export function validateOptionField(value) {
    return {
        valid: true,
        error: '',
    };
}
/** 层级 */
function getPathNodes(node, nodeMap) {
    const pathNodes = [];
    let currentNode = node;
    while (currentNode && currentNode.id) {
        pathNodes.push(currentNode);
        currentNode = nodeMap[currentNode.parent_id];
    }
    return pathNodes.reverse();
}
export function transformLayerField(value, treeData) {
    if (!treeData || !treeData.length || !value || !value.length) {
        return [];
    }
    const tagItems = [];
    const nodeMap = {};
    forEachTree(treeData, (node) => {
        nodeMap[node.id] = node;
        if (node.id && value.includes(node.id)) {
            const pathNodes = getPathNodes(node, nodeMap);
            tagItems.push({
                id: node.id,
                label: node.name,
                data: node,
                pathNodes,
                path: _.map(pathNodes, ({ name }) => name).join('/'),
            });
        }
    });
    return _.sortBy(tagItems, [({ id }) => {
            return _.indexOf(value, id);
        }]);
}
export function validateLayerField(value) {
    return {
        valid: true,
        error: '',
    };
}
